import styled, {keyframes} from "styled-components";

export const HomePageWrapper = styled.section`
  display: flex;
  width: 100%;
  flex-direction: column;
  background-color: rgb(239, 243, 248);
  position: relative;
`;
export const PageBackground = styled.div`
  height: 256px;
  background-image: url("https://gos3.ibcdn.com/gi-orange-theme-bg-1693817290.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center bottom;
  width: 100%;
`;
export const PageContentWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 120rem;
  margin: 0px auto;
  margin-top: -250px;

`;
export const PageHeader = styled.h1(
  (props) => `
    font-size: 2.2rem;
    font-family: ${props.theme.font.fontFamily};
    font-weight: 600;
    z-index: 9;
    color: rgb(255, 255, 255);
    margin: 2rem 0px;
  `
);

export const SearchBlock = styled.section`
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-bottom: 4rem;
`;

export const ExploreBtn = styled.section`
  display: flex;
  width: 100%;
  flex-direction: row;
`;

export const OfferBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  z-index: 3;
`;
export const Overlay = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 5;
  background: rgba(0, 0, 0, 0.5);
`;

const ButtonBase = styled.button(
  (props) => `
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border:none;
    background-color: ${props.theme.colors.goBrandOrange.base};
    color: ${props.theme.colors.goWhite.base};
    font-family: ${props.theme.font.fontFamily};
    font-weight: 600;
    text-transform: uppercase;
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    font-size:${props.theme.font.custom(16)};
    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }
  `
);

const SmallSectionHeader = styled.h2(
  props => `
    font-weight: 600;
    font-size: ${props.theme.font.large};
    font-family: ${props.theme.font.fontFamily};
    `,
);

export const ExploreBtnText = styled(SmallSectionHeader)(
  props => `
  color: ${props.theme.colors.goWhite.base};
  padding-right:${props.theme.spacing.base};
  `,
);

const AnimateUpDown = keyframes`
    0%   { transform: translateY(0); }
    50%  { transform: translateY(-20px); }
    100% { transform: translateY(0); }
`;

export const ExploreMoreBtn = styled(ButtonBase)`
  position: relative;
  margin: 0 auto;
  margin-bottom: 1rem;
  height: 5rem;
  text-transform: capitalize;
  width: fit-content;
  background-image: linear-gradient(105deg, #1149f3, #00c3ff 100%);
  padding: ${(props) => props.theme.spacing.custom(14)}
    ${(props) => props.theme.spacing.xlarge};
  border-radius: ${(props) => props.theme.misc.borderRadius.custom(26)};
  animation-name: ${AnimateUpDown};
  animation-duration: 1s;
  animation-iteration-count: 3;
  transform-origin: bottom;
  animation-timing-function: linear;
`;
